<!-- SUMMARY -->
<div *ngIf="mode === 'summary'">

  <div class="edit">
    <div class="categoria-header">
      <h3 *ngIf="!canShowEditButton">Estos son tus fondos en {{producto}}</h3>
      <h3 *ngIf="canShowEditButton">Fondos de {{producto}} destinados a tu pensión</h3>
      <p *ngIf="canShowEditButton">Puedes editar el monto que destinarás.</p>
    </div>

    <div *ngIf="fondosConCategorias.length > 0" class="fondos-list">
      <table class="fondos-table summary-table-desktop">
        <thead>
          <tr>
            <th class="col-regimen">Régimen</th>
            <th class="col-fondo">Fondo</th>
            <th class="col-cuotas">Saldo en cuotas</th>
            <th class="col-pesos">{{ summaryAmountHeader }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let grupoRegimen of filasResumenAgrupadasPorRegimen; let g = index">
            <tr *ngFor="let fila of grupoRegimen.filas; let i = index; let isFirst = first; let isLast = last"
              class="fondo-row" [class.group-start]="isFirst" [class.group-end]="isLast"
              [class.regimen-row-internal]="!isLast">
              <td *ngIf="i === 0" class="col-regimen" [attr.rowspan]="grupoRegimen.filas.length">{{ grupoRegimen.regimen
                }}</td>
              <td class="col-fondo">Fondo {{ fila.fondo.id }}</td>
              <td class="col-cuotas">{{ fila.fondo.shareBalance }}</td>
              <td class="col-pesos">${{ getSummaryAmountValue(fila.fondo, fila.categoria) }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <div class="summary-mobile-list">
        <ng-container *ngFor="let grupoRegimen of filasResumenAgrupadasPorRegimen">
          <div *ngFor="let fila of grupoRegimen.filas" class="summary-mobile-card">
            <div class="summary-mobile-row">
              <span class="summary-mobile-label">Régimen</span>
              <span class="summary-mobile-value">{{ grupoRegimen.regimen }}</span>
            </div>
            <div class="summary-mobile-row">
              <span class="summary-mobile-label">Fondo</span>
              <span class="summary-mobile-value">Fondo {{ fila.fondo.id }}</span>
            </div>
            <div class="summary-mobile-row">
              <span class="summary-mobile-label">Saldo en cuotas</span>
              <span class="summary-mobile-value">{{ fila.fondo.shareBalance }}</span>
            </div>
            <div class="summary-mobile-row">
              <span class="summary-mobile-label">{{ summaryAmountHeader }}</span>
              <span class="summary-mobile-value">${{ getSummaryAmountValue(fila.fondo, fila.categoria) }}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <p class="edit-importante">(*)Los montos son referenciales y podrían variar según la variación del valor cuota</p>
    </div>

    <div *ngIf="canShowEditButton" class="cont-btn-edit">
      <button type="button" (click)="openEditFromSummary()" class="btn-edit">
        Editar
      </button>
    </div>
  </div>
</div>


<!-- EDIT -->
<!-- EDIT MODE -->
<div *ngIf="mode === 'edit'" class="edit-container" [formGroup]="form">

  <!-- HEADER -->
  <div class="header">
    <h3>{{question.title}}</h3>
    <p>Ingresa el monto que destinarás por fondo en cada régimen.</p>
  </div>

  <!-- FONDOS Y CATEGORÍAS (Si existen datos del balance) -->
  <div *ngIf="accountBalance && fondosConCategorias.length > 0" class="fondos-categorias-section">

    <!-- POR CADA CATEGORÍA: TABLA DE FONDOS -->
    <div *ngFor="let categoriaDesglose of categoriasDesglosadaPorRegimen; trackBy: trackByCategoriaIndex"
      class="categoria-container">

      <!-- POR CADA RÉGIMEN DENTRO DE LA CATEGORÍA -->
      <div *ngFor="let regimen of categoriaDesglose.regimenes; trackBy: trackByRegimenTaxCode"
        class="regimen-container">
        <div class="categoria-header">
          <span class="categoria-name">{{ regimen.glosaCodigoRegimen }}</span>
          <p>{{ getTextoSaldoMinimoRegimen(regimen) }}</p>
        </div>

        <!-- TABLA DE FONDOS DEL RÉGIMEN -->
        <div *ngIf="regimen.fondos && regimen.fondos.length > 0" class="fondos-list">
          <table class="fondos-table-edit edit-table-desktop">
            <thead>
              <tr>
                <th class="col-fondo">Fondo</th>
                <th class="col-cuotas">Saldo en cuotas</th>
                <th class="col-pesos">Saldo en pesos*</th>
                <th class="col-editar">Monto destinado en pesos*</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fondo of regimen.fondos; let i = index; trackBy: trackByFondoId" class="fondo-row">
                <td class="col-fondo">Fondo {{ fondo.id }}</td>
                <td class="col-cuotas">{{ fondo.shareBalance }}</td>
                <td class="col-pesos">${{ fondo.clpBalance }}</td>
                <td class="col-editar">
                  <div class="monto-destino-field"
                    [class.monto-destino-field--error]="getAmountError(fondo.controlName)">
                    <label [for]="fondo.controlName" class="field-label-sr-only">
                      Monto destinado en pesos para Fondo {{ fondo.id }}
                    </label>
                    <div class="monto-destino-input-wrap">
                      <input
                        [id]="fondo.controlName"
                        class="categoria-amount-input"
                        appCurrencyFormat
                        [clampToMax]="false"
                        [maxAmount]="fondo.clpBalanceRaw"
                        [formControlName]="fondo.controlName"
                        (input)="onAmountInput($event, fondo, categoriaDesglose.category)"
                        (blur)="onAmountBlur($event, fondo, categoriaDesglose.category)"
                        placeholder="$ 0"
                      />
                      <ion-icon
                        *ngIf="getAmountError(fondo.controlName)"
                        name="alert-circle"
                        class="monto-destino-error-icon"
                        aria-hidden="true">
                      </ion-icon>
                    </div>
                    <p *ngIf="getAmountError(fondo.controlName)" class="monto-destino-error">
                      {{ getAmountError(fondo.controlName) }}
                    </p>
                    <div class="incluir-saldo-check">
                      <ion-checkbox
                        [attr.aria-labelledby]="fondo.controlName + '_incluir_label'"
                        [checked]="isIncludeAll(fondo.controlName)"
                        (pointerdown)="onIncludeAllPointerDown($event)"
                        (mousedown)="onIncludeAllPointerDown($event)"
                        (ionChange)="onIncludeAllChange(fondo, categoriaDesglose.category, $any($event).detail.checked)">
                      </ion-checkbox>
                      <span
                        [id]="fondo.controlName + '_incluir_label'"
                        class="incluir-saldo-check__label">
                        Incluir todo el saldo
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="edit-mobile-list">
            <div *ngFor="let fondo of regimen.fondos; let i = index; trackBy: trackByFondoId" class="edit-mobile-card">
              <div class="edit-mobile-row">
                <span class="edit-mobile-label">Fondo</span>
                <span class="edit-mobile-value">Fondo {{ fondo.id }}</span>
              </div>
              <div class="edit-mobile-row">
                <span class="edit-mobile-label">Saldo en cuotas</span>
                <span class="edit-mobile-value">{{ fondo.shareBalance }}</span>
              </div>
              <div class="edit-mobile-row">
                <span class="edit-mobile-label">Saldo en pesos</span>
                <span class="edit-mobile-value">${{ fondo.clpBalance }}</span>
              </div>

              <div class="edit-mobile-input-block">
                <label [for]="fondo.controlName + '_mobile'" class="edit-mobile-input-label">
                  Monto destinado en pesos*
                </label>
                <div class="monto-destino-field"
                  [class.monto-destino-field--error]="getAmountError(fondo.controlName)">
                  <div class="monto-destino-input-wrap">
                    <input
                      [id]="fondo.controlName + '_mobile'"
                      class="categoria-amount-input"
                      appCurrencyFormat
                      [clampToMax]="false"
                      [maxAmount]="fondo.clpBalanceRaw"
                      [formControlName]="fondo.controlName"
                      (input)="onAmountInput($event, fondo, categoriaDesglose.category)"
                      (blur)="onAmountBlur($event, fondo, categoriaDesglose.category)"
                      placeholder="$ 0"
                    />
                    <ion-icon
                      *ngIf="getAmountError(fondo.controlName)"
                      name="alert-circle"
                      class="monto-destino-error-icon"
                      aria-hidden="true">
                    </ion-icon>
                  </div>
                  <p *ngIf="getAmountError(fondo.controlName)" class="monto-destino-error">
                    {{ getAmountError(fondo.controlName) }}
                  </p>
                  <div class="incluir-saldo-check">
                    <ion-checkbox
                      [attr.aria-labelledby]="fondo.controlName + '_incluir_label_mobile'"
                      [checked]="isIncludeAll(fondo.controlName)"
                      (pointerdown)="onIncludeAllPointerDown($event)"
                      (mousedown)="onIncludeAllPointerDown($event)"
                      (ionChange)="onIncludeAllChange(fondo, categoriaDesglose.category, $any($event).detail.checked)">
                    </ion-checkbox>
                    <span
                      [id]="fondo.controlName + '_incluir_label_mobile'"
                      class="incluir-saldo-check__label">
                      Incluir todo el saldo
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="edit-importante">(*)Los montos son referenciales y podrían variar según la variación del valor cuota</p>
    </div>

    <!-- ACTIONS -->
    <div class="actions">
      <button
        type="button"
        class="btn-save"
        [disabled]="hasActiveAmountErrors()"
        (click)="save()">
        Guardar
      </button>
    </div>

  </div>
</div>
<div *ngIf="mode === 'summary' && isLastQuestion && resumenSaldoInterno.length > 0" class="resumen-general">
  <div class="categoria-header">
    <h3>Aportes voluntarios destinados a tu pensión</h3>
    <span class="categoria-name">Conoce el monto total de tus ahorros voluntarios que irán a tu pensión</span>
  </div>

  <div class="fondos-list">
    <table class="fondos-table summary-table-desktop">
      <thead>
        <tr>
          <th class="col-regimen">Tipo de Cuenta</th>
          <th class="col-fondo">Fondo</th>
          <th class="col-cuotas">Saldo Cuotas</th>
          <th class="col-pesos">Saldo pesos</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let grupoTipoCuenta of resumenAgrupadoPorTipoCuenta; trackBy: trackByResumenTipoCuenta">
          <tr
            *ngFor="let registro of grupoTipoCuenta.filas; let i = index; let isFirst = first; let isLast = last; trackBy: trackByResumenRegistro"
            class="fondo-row" [class.group-start]="isFirst" [class.group-end]="isLast"
            [class.regimen-row-internal]="!isLast">
            <td *ngIf="i === 0" class="col-regimen" [attr.rowspan]="grupoTipoCuenta.filas.length">{{
              grupoTipoCuenta.tipoCuenta }}</td>
            <td class="col-fondo">Fondo {{ registro.tipoFondo }}</td>
            <td class="col-cuotas">{{ formatCuotasSegunMonto(registro.cuotaSegunMontoIngresado) }}</td>
            <td class="col-pesos">${{ formatMontoResumen(registro.valorMontoSolicitado) }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="summary-mobile-list">
      <ng-container *ngFor="let grupoTipoCuenta of resumenAgrupadoPorTipoCuenta; trackBy: trackByResumenTipoCuenta">
        <div *ngFor="let registro of grupoTipoCuenta.filas; trackBy: trackByResumenRegistro" class="summary-mobile-card">
          <div class="summary-mobile-row">
            <span class="summary-mobile-label">Tipo de Cuenta</span>
            <span class="summary-mobile-value">{{ grupoTipoCuenta.tipoCuenta }}</span>
          </div>
          <div class="summary-mobile-row">
            <span class="summary-mobile-label">Fondo</span>
            <span class="summary-mobile-value">Fondo {{ registro.tipoFondo }}</span>
          </div>
          <div class="summary-mobile-row">
            <span class="summary-mobile-label">Saldo Cuotas</span>
            <span class="summary-mobile-value">{{ formatCuotasSegunMonto(registro.cuotaSegunMontoIngresado) }}</span>
          </div>
          <div class="summary-mobile-row">
            <span class="summary-mobile-label">Saldo pesos</span>
            <span class="summary-mobile-value">${{ formatMontoResumen(registro.valorMontoSolicitado) }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <p class="edit-importante">(*)Los montos son referenciales y podrían variar según la variación del valor cuota</p>

    <div class="resumen-total">
      <span>Total fondos destinados a tu pensión</span>
      <span class="total-amount">${{ formatMontoResumen(totalResumen) }}</span>
    </div>
  </div>

  <div class="info-box">
    <div class="icon-container info-box-icon">
      <ion-icon class="i-info-fill-2" aria-hidden="true"></ion-icon>
    </div>
    <div>
      <p class="info-box-title">Te sugerimos</p>
      <p class="info-box-description">
        Como referencia, aportando <strong>8 millones tu pensión podría incrementar 1 UF.</strong> Asesórate previamente
        con ejecutivo en
        una <button type="button" class="link link-button" aria-label="Agendar Video Atención"
          (click)="goToVideoAtencion()">
          <strong>video atención</strong>
        </button> o ingresando al <button type="button" class="link link-button" aria-label="Agendar Video Atención"
          (click)="goToEstimador()">
          <strong>estimador de pensión</strong>
        </button>, para saber cuánto impactará el monto que traspases a tu
        pensión.
      </p>
    </div>

  </div>
</div>